import ReelVideo from '@components/common/ReelVideo/ReelVideo'
import { IStreamingVideo } from 'app/_components/ContentfulPage/contentfulPage.types'
import { PostOrPage, PostsOrPages } from '@tryghost/content-api'
import React from 'react'
import {
  centerImageCollection,
  leftImageCollection,
  rightImageCollection,
} from './InTheWildDesktop.utils'

export function InTheWildDesktop({
  posts,
  videos,
}: {
  posts: Partial<PostOrPage>[] | []
  videos: IStreamingVideo[]
}) {
  const imageGroups = [
    [posts?.[0], posts?.[1], posts?.[2]],
    [posts?.[3], posts?.[4], posts?.[5]],
    [posts?.[6], posts?.[7], posts?.[8]],
  ]

  return (
    <div
      className={`grid grid-cols-2 grid-rows-9 md:grid-cols-6 md:grid-rows-3 w-full gap-4 md:h-[50vw] md:max-h-[650px]`}
    >
      {videos?.[0] ? (
        <ReelVideo
          playbackId={`${videos[0]?.video?.playbackId}`}
          title={videos[0]?.title}
          wrapperClassName="row-start-1 col-start-1 row-span-3 col-span-2 md:ml-20"
          videoClassName="object-contain sm:object-cover rounded-xl"
        />
      ) : (
        leftImageCollection(imageGroups.shift())
      )}

      {centerImageCollection(imageGroups.shift())}

      {videos?.[1] ? (
        <ReelVideo
          playbackId={`${videos[1]?.video?.playbackId}`}
          title={videos[1]?.title}
          wrapperClassName="row-start-7 col-start-1 md:row-start-1 md:col-start-5 row-span-3 col-span-2 md:mr-20"
          videoClassName="object-contain sm:object-cover object-cover rounded-xl"
        />
      ) : (
        rightImageCollection(imageGroups.shift())
      )}
    </div>
  )
}
